import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentTab: 0,
};

const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    setCurrentTab: (state, action) => {
      state.currentTab = action.payload;
    },
  },
});

export const { setCurrentTab } = eventsSlice.actions;
export default eventsSlice.reducer;
